/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_InfoInputs */

const en_project_info = /** @type {(inputs: Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Info`)
};

const fr_project_info = /** @type {(inputs: Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infos du projet`)
};

const de_project_info = /** @type {(inputs: Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektinformationen`)
};

const it_project_info = /** @type {(inputs: Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni sul progetto`)
};

const ru_project_info = /** @type {(inputs: Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Информация о проекте`)
};

const es_project_info = /** @type {(inputs: Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información del proyecto`)
};

const zh_cn2_project_info = /** @type {(inputs: Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目信息`)
};

const ja_project_info = /** @type {(inputs: Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクト情報`)
};

const hi_project_info = /** @type {(inputs: Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परियोजना की जानकारी`)
};

const pt_pt2_project_info = /** @type {(inputs: Project_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informações do projeto`)
};

/**
* | output |
* | --- |
* | "Project Info" |
*
* @param {Project_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_info = /** @type {((inputs?: Project_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_project_info(inputs)
	if (locale === "de") return de_project_info(inputs)
	if (locale === "it") return it_project_info(inputs)
	if (locale === "ru") return ru_project_info(inputs)
	if (locale === "es") return es_project_info(inputs)
	if (locale === "zh-CN") return zh_cn2_project_info(inputs)
	if (locale === "ja") return ja_project_info(inputs)
	if (locale === "hi") return hi_project_info(inputs)
	if (locale === "pt-PT") return pt_pt2_project_info(inputs)
	return en_project_info(inputs)
});